import { useState, useEffect } from "react";
import {
  Box,
  Card,
  Button,
  TextField,
  Autocomplete,
  CardMedia,
  Menu,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import { UseProduct4 } from "./UseProduct4";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../../RecoilStates";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";
import { SketchPicker } from "react-color";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ProductOfferFrame(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate2, UpdateProductOffer, AddProductOffer } = UseProduct4();
  const [offers, setOffers] = useState();
  const headerColors = ["بدون رنگ", "primary", "secondary"];
  const { isSmall } = useBreakpoints();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [state, setState] = useState({
    id: undefined,
    aid: props.aid ? props.aid : "",
    headerColorName: null,
    title: undefined,
    backgroundColor: undefined,
    moreURL: undefined,
    moreTitle: undefined,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: "",
    file2: undefined,
    url2: "",
    file3: undefined,
    url3: "",
  });

  useEffect(() => {
    if (props.offers) {
      setState({
        id: props.offers.id,
        aid: props.aid,
        headerColorName: props.offers.headerColorName,
        title: props.offers.title,
        moreURL: props.offers.moreURL,
        moreTitle: props.offers.moreTitle,
        backgroundColor: props.offers.backgroundColor,
      });
      setImgState({
        file: undefined,
        url: props.offers.banner ? props.offers.banner : "",
        file2: undefined,
        url2: props.offers.banner2 ? props.offers.banner2 : "",
        file3: undefined,
        url3: props.offers.backgroundImage ? props.offers.backgroundImage : "",
      });
    }
  }, [props.offers]);

  const [errorState, setErrorState] = useState({
    title: false,
    productCount: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      ...imgState,
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      file2: file[0],
      url2: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImageBack = (file) => {
    setImgState({
      ...imgState,
      file3: file[0],
      url3: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Box
      sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={2}
    >
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          value={state.title ? state.title : ""}
          error={errorState.title}
          label="عنوان"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 4"}>
        <TextField
          fullWidth
          value={state.moreTitle ? state.moreTitle : ""}
          label="عنوان لینک"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreTitle: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 6"}>
        <TextField
          fullWidth
          value={state.moreURL ? state.moreURL : ""}
          label="آدرس لینک"
          size="small"
          sx={{
            textarea: {
              direction: "rtl",
            },
          }}
          multiline
          rows={2}
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreURL: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span 3"}>
        <Autocomplete
          size="small"
          value={state.headerColorName ? state.headerColorName : ""}
          onChange={(event, newValue) => {
            if (newValue == "بدون رنگ") {
              setState({
                ...state,
                headerColorName: null,
              });
            } else if (newValue) {
              setState({
                ...state,
                headerColorName: newValue,
              });
            } else {
              setState({
                ...state,
                headerColorName: null,
              });
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return value == "" || option === value;
          }}
          sx={{ width: "80%" }}
          getOptionLabel={(option) => option}
          fullWidth
          options={headerColors}
          renderInput={(params) => (
            <TextField variant="outlined" {...params} label="رنگ هدر" />
          )}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}
      <Box
        gridColumn={isSmall ? "span 12" : "span 6"}
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 4,
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "150px", height: "auto" }}>
              <Card
                sx={{
                  bgcolor: imgState.url && "#d7d7d7",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.url ? imgState.url : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage2(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "300px", height: "auto" }}>
              <Card
                sx={{
                  bgcolor: imgState.url2 && "#d7d7d7",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.url2 ? imgState.url2 : "/static/img/nobanner.jpg"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span  3"}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography color="secondary" variant="body1">
            رنگ پس زمینه:
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D7D7D7",
              borderRadius: 2,
              p: 1,
              ml: 2,
            }}
          >
            <Avatar
              sx={{
                bgcolor: state.backgroundColor,
                boxShadow: 3,
                width: 65,
                height: 30,
                borderRadius: 1,
                mx: 1,
              }}
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              {" "}
            </Avatar>
            <Typography sx={{ direction: "rtl" }} variant="body1">
              {state.backgroundColor ? state.backgroundColor : ""}
            </Typography>
          </Box>
          {state.backgroundColor ? (
            <Button
              sx={{ ml: 2 }}
              variant="outlined"
              onClick={(color) => {
                setState({ ...state, backgroundColor: "" });
              }}
            >
              حذف
            </Button>
          ) : (
            ""
          )}
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          sx={{
            "& .muirtl-6hp17o-MuiList-root-MuiMenu-list": {
              py: 0,
            },
          }}
        >
          <SketchPicker
            sx={{ position: "relative", top: "-130px" }}
            color={state.backgroundColor ? state.backgroundColor : ""}
            onChangeComplete={(color) => {
              setState({ ...state, backgroundColor: color.hex });
            }}
          />
        </Menu>
      </Box>
      {!isSmall && <Box gridColumn="span 9"></Box>}
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmall ? "column" : "row",
          alignItems: "flex-start",
          gap: 2,
        }}
        gridColumn="span 12"
      >
        <Typography sx={{ mb: 1 }} color="secondary" variant="body1">
          تصویر پس زمینه:
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImageBack(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box>
                <Card
                  sx={{
                    width: "200px",
                    height: "auto",
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.url3 ? imgState.url3 : "/static/img/nobanner.jpg"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <IconButton
            onClick={() => {
              setState({ ...state, backgroundImage: "" });
              setImgState({
                file3: undefined,
                url3: undefined,
              });
            }}
            sx={{
              display: "flex",
              // bgcolor: "#dec2ff",
              boder: "1px solid gray",
              visibility: imgState.url3 ? "visible" : "hidden",
            }}
          >
            <DeleteIcon sx={{ color: "secondary.main" }} />
          </IconButton>
        </Box>
      </Box>
      <Box
        gridColumn="span 12"
        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
      >
        <Button
          sx={{ mr: 2, width: "100px" }}
          variant="contained"
          onClick={() => {
            if (validate2(state, setErrorState) == 200) {
              setProgress(true);
              if (state.id == 0) {
                AddProductOffer(
                  state,
                  imgState.file,
                  imgState.file2,
                  imgState.file3,
                  (calback) => {
                    props.callback();
                  }
                );
                return;
              } else {
                UpdateProductOffer(
                  state,
                  imgState.file,
                  imgState.file2,
                  imgState.file3,
                  (calback) => {
                    props.callback();
                  }
                );
              }
            }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
